import { render, staticRenderFns } from "./VFair.vue?vue&type=template&id=1a2b1d86&scoped=true&"
import script from "./VFair.vue?vue&type=script&lang=ts&"
export * from "./VFair.vue?vue&type=script&lang=ts&"
import style0 from "./VFair.vue?vue&type=style&index=0&id=1a2b1d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b1d86",
  null
  
)

export default component.exports